import styled from "styled-components";
import { motion } from "framer-motion";
import { letterAnimation } from "../animation";
import Project from "./Project";

const Projects = () => {
  return (
    <Section>
      <Container id="projects">
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ staggerChildren: 0.1 }}
          className="title"
        >
          <motion.span variants={letterAnimation}>.</motion.span>
          <motion.span variants={letterAnimation}>.</motion.span>
          <motion.span variants={letterAnimation}>.</motion.span>
          <motion.span variants={letterAnimation}>P</motion.span>
          <motion.span variants={letterAnimation}>R</motion.span>
          <motion.span variants={letterAnimation}>O</motion.span>
          <motion.span variants={letterAnimation}>J</motion.span>
          <motion.span variants={letterAnimation}>E</motion.span>
          <motion.span variants={letterAnimation}>C</motion.span>
          <motion.span variants={letterAnimation}>T</motion.span>
          <motion.span variants={letterAnimation}>S</motion.span>
        </motion.div>
        <div className="projects">
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="Telex"
              description="Working as one of the backend devs at HNG Tech to build Telex, a notification app that monitors the performance of integrated applications"
              stacks={["GO", "Gin", "PostgreSQL"]}
              link="telex.im"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="User Authentication System"
              description="Built a robust registration,login and organization management API"
              stacks={["GO", "Gin", "PostgreSQL"]}
              link="github.com/Iretoms/hng-task-two"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="File Storage System"
              description="Built an API with two end points for uploading to and downloading from the database"
              stacks={["GO", "Gin", "MongoDB", "Docker"]}
              link="github.com/Iretoms/file-storage-system"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="Bunda Solutions Limited"
              description="Revamped the company's website"
              stacks={["ReactJs", "Styled-components", "Framer-motion"]}
              link="bundasolutions.com"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="JobsMeetDevs Website"
              description="A website for an upcoming start-up. Work in progress."
              stacks={["ReactJs", "Styled-components", "Framer-motion"]}
              link="job-meet-devs.netlify.app"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="getlinked Hackathon"
              description="With the aid of a figma file, built a landing page for the hackathon challenge"
              stacks={["ReactJs", "Styled-components"]}
              link="iretoms-getlinked-hackathon.netlify.app"
            />
          </motion.div>
          <motion.div
            initial="hide"
            whileInView={"show"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.1 }}
          >
            <Project
              name="DevSearcher"
              description="This makes use of the github api to search and display users information."
              stacks={["ReactJs", "Styled-components", "ReduxToolkit"]}
              link="devs-searcher.vercel.app"
            />
          </motion.div>
        </div>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 3rem;
  width: 100%;
  min-height: 100vh;
`;

const Container = styled.div`
  width: 85%;
  margin: 0 auto;
  .title {
    text-align: right;
    overflow: hidden;
    span {
      display: inline-block;
      font-family: "Antonio", sans-serif;
      font-weight: 700;
      font-size: 8rem;
      color: rgba(149, 149, 149, 0.2);
    }
  }

  .projects {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  @media screen and (max-width: 600px) {
    .title {
      width: 100%;
      span {
        font-size: 4.5rem;
      }
    }

    .projects {
      gap: 1.5rem;
    }
  }
`;

export default Projects;
